import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert, Spinner, Modal, Badge } from 'react-bootstrap';
import { FaCalculator, FaSave, FaFileExcel, FaFileAlt, FaTrash, FaSearch, FaCar } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import { validateTCNumber, validatePhoneNumber } from '../utils/validators';
import { getBrands, getModelsByBrand } from '../services/vehicleDataService';


// *** VKN validation (Frontend için basit versiyon) ***
const validateVKNNumber = (vknNo) => {
    if (!vknNo || typeof vknNo !== 'string') return false;
    const cleanVknNo = vknNo.replace(/\D/g, '');
    return cleanVknNo.length === 10 && cleanVknNo[0] !== '0';
};

const ReportGeneratorPage = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [tcError, setTcError] = useState('');

    // haricide drop down marka model drowp down icin
    const [vehicleBrands, setVehicleBrands] = useState([]);
    const [vehicleModels, setVehicleModels] = useState([]);
    const [loadingBrands, setLoadingBrands] = useState(false);
    const [loadingModels, setLoadingModels] = useState(false);

    // *** YENİ: Kimlik numarası error state'i (TCKN/VKN için) ***
    const [identityError, setIdentityError] = useState('');
    const [phoneError, setPhoneError] = useState('');


    // *** YENİ: ŞASE ile araç arama state'leri ***
    const [searchingVehicle, setSearchingVehicle] = useState(false);
    const [foundVehicle, setFoundVehicle] = useState(null);
    const [chassisSearchError, setChassisSearchError] = useState('');
    const [activeTab, setActiveTab] = useState('stock'); // 'stock' veya 'external'
    const [plateSearchError, setPlateSearchError] = useState('');
    const [searchingByPlate, setSearchingByPlate] = useState(false);

    // Backend'in beklediği formata uygun state yapısı
    const [customerData, setCustomerData] = useState({
        name: '',
        phone: '',
        email: '',
        tcNo: '',
        address: ''
    });

    // *** YENİ: Kimlik türü seçimi (TCKN/VKN) ***
    const [identityType, setIdentityType] = useState('TCKN');

    // *** YENİ: Kefil bilgileri state'i (Opsiyonel) ***
    const [guarantorData, setGuarantorData] = useState({
        name: '',
        tcNo: '',
        address: '',
        identityType: 'TCKN' // *** YENİ: Kefil için ayrı kimlik türü ***
    });

    const [hasGuarantor, setHasGuarantor] = useState(false); // Kefil var mı checkbox'ı
    const [guarantorError, setGuarantorError] = useState('');

    const [vehicleData, setVehicleData] = useState({
        make: '',
        model: '',
        price: 0,
        plate: '',
       // motorNo: '',
        saseNo: '',
        tramer: 'YOK',
        tramerAmount: 0,
        tramerDescription: ''
    });

    const [financialData, setFinancialData] = useState({
        downPayment: 0,
        interestRate: 7.0,
        term: 1
    });

    // Senet başlangıç tarihi state'i
    const [senetBaslangicTarihi, setSenetBaslangicTarihi] = useState('');

    const [notes, setNotes] = useState('');

    // Formatlanmış fiyat ve peşinat için ayrı state'ler
    const [formattedPrice, setFormattedPrice] = useState('0');
    const [formattedDownPayment, setFormattedDownPayment] = useState('0');

    const [formattedTramerAmount, setFormattedTramerAmount] = useState('0');

    // *** YENİ: Kasko state'leri ***
    const [kaskoYapildi, setKaskoYapildi] = useState(false);
    const [kaskoBedeli, setKaskoBedeli] = useState(0);
    const [formattedKaskoBedeli, setFormattedKaskoBedeli] = useState('0');

    const [calculations, setCalculations] = useState(null);

    // *** YENİ: Customer search state'leri ***
    const [searchingCustomer, setSearchingCustomer] = useState(false);
    const [foundCustomer, setFoundCustomer] = useState(null);
    const [customerSearchError, setCustomerSearchError] = useState('');
    const [showConfirmModal, setShowConfirmModal] = useState(false);


    // Component içine ekle
    const fetchVehicleBrands = async () => {
        setLoadingBrands(true);
        try {
            const response = await getBrands(); 
            if (response.success) {
                setVehicleBrands(response.data || []);
            }
        } catch (error) {
            console.error('Marka listesi alınamadı:', error);
        } finally {
            setLoadingBrands(false);
        }
    };

    const fetchVehicleModels = async (brand) => {
        if (!brand) {
            setVehicleModels([]);
            return;
        }

        setLoadingModels(true);
        try {
            const response = await getModelsByBrand(brand);
            if (response.success) {
                setVehicleModels(response.data || []);
            }
        } catch (error) {
            console.error('Model listesi alınamadı:', error);
            setVehicleModels([]);
        } finally {
            setLoadingModels(false);
        }
    };

    // Component mount olduğunda markaları çek
    useEffect(() => {
        fetchVehicleBrands();
    }, []);

    // Marka değiştiğinde modelleri çek
    useEffect(() => {
        if (activeTab === 'external' && vehicleData.make) {
            fetchVehicleModels(vehicleData.make);
        } else {
            setVehicleModels([]);
        }
    }, [vehicleData.make, activeTab]);

    // Sayıyı binlik ayırıcı ile formatlama
    const formatNumber = (num) => {
        if (!num || num === 0) return '0';
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    // String'den binlik ayırıcıları kaldır ve sayıya çevir
    const parseFormattedNumber = (str) => {
        if (!str || str === '') return 0;
        const cleaned = str.replace(/\./g, '');
        return parseInt(cleaned, 10) || 0;
    };

    /**
     * DEFAULT SENET BAŞLANGIÇ TARİHİ HESAPLAMA - DURUM-1
     * ===================================================
     * 
     * Mantık: Bugünün aynı gün sayısı, bir sonraki ay + hafta sonu kontrolü
     * 
     * ÖRNEK:
     * - Bugün: 14/8/2025 (Perşembe)
     * - Hedef: 14/9/2025 → Pazar ise 15/9/2025 (Pazartesi)
     * - Hedef: 14/9/2025 → Cumartesi ise 13/9/2025 (Cuma)
     */
    useEffect(() => {
        console.log('🗓️ Default senet tarihi hesaplanıyor...');

        const today = new Date();
        const defaultDate = new Date(today);

        // 30 gun sonrasi
        defaultDate.setDate(today.getDate() + 30);

        // HAFTA SONU KONTROLÜ (Backend ile aynı mantık)
        const originalDate = new Date(defaultDate);
        if (defaultDate.getDay() === 0) { // Pazar
            defaultDate.setDate(defaultDate.getDate() + 1); // Pazartesi'ye AT
            console.log(`📅 Default tarih: ${originalDate.toISOString().split('T')[0]} (Pazar) → ${defaultDate.toISOString().split('T')[0]} (Pazartesi)`);
        } else if (defaultDate.getDay() === 6) { // Cumartesi
            defaultDate.setDate(defaultDate.getDate() - 1); // Cuma'ya ÇEK
            console.log(`📅 Default tarih: ${originalDate.toISOString().split('T')[0]} (Cumartesi) → ${defaultDate.toISOString().split('T')[0]} (Cuma)`);
        } else {
            console.log(`📅 Default tarih: ${defaultDate.toISOString().split('T')[0]} (${['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'][defaultDate.getDay()]})`);
        }

        const formattedDate = defaultDate.toISOString().split('T')[0];
        setSenetBaslangicTarihi(formattedDate);

        console.log('✅ Default senet tarihi ayarlandı:', formattedDate);
    }, []);

    // Kimlik türü değiştiğinde handler
    const handleIdentityTypeChange = (newType) => {
        setIdentityType(newType);
        // Kimlik numarasını sıfırla
        setCustomerData(prev => ({ ...prev, tcNo: '' }));
        // Hataları temizle
        setTcError('');
        setIdentityError('');
    };



    // *** ŞASE NO ile araç arama fonksiyonu ***
    const handleSearchByChassis = async () => {
        if (!vehicleData.saseNo || vehicleData.saseNo.length < 10) {
            setChassisSearchError('Geçerli bir şase numarası giriniz (min 10 karakter)');
            return;
        }

        setSearchingVehicle(true);
        setChassisSearchError('');
        setError('');
        setSuccess('');

        try {
            console.log(`🚗 Şase ile araç aranıyor: ${vehicleData.saseNo}`);

            const response = await api.get(`/vehicles/search/${vehicleData.saseNo}`);

            if (response.data.success && response.data.vehicles.length > 0) {
                const vehicle = response.data.vehicles[0]; // İlk bulunan aracı al
                setFoundVehicle(vehicle);

                // Araç bilgilerini otomatik doldur
                setVehicleData(prev => ({
                    ...prev,
                    make: vehicle.brand || prev.make,
                    model: vehicle.model || prev.model,
                    plate: vehicle.plateNumber || prev.plate,
                   // motorNo: vehicle.engineNumber || prev.motorNo,
                    // saseNo aynı kalır (zaten arama yapılan)
                    price: vehicle.purchasePrice || prev.price,
                    tramer: vehicle.hasTramer ? 'VAR' : 'YOK',
                    tramerAmount: vehicle.tramerAmount || 0,
                    tramerDescription: vehicle.tramerDescription || ''
                }));

                // Formatlanmış fiyatları güncelle
                if (vehicle.purchasePrice > 0) {
                    setFormattedPrice(formatNumber(vehicle.purchasePrice));
                }
                if (vehicle.tramerAmount > 0) {
                    setFormattedTramerAmount(formatNumber(vehicle.tramerAmount));
                }

                setSuccess(`🚗 ${vehicle.brand} ${vehicle.model} (${vehicle.plateNumber}) aracı bulundu ve bilgiler otomatik dolduruldu!`);
                console.log('✅ Araç bulundu ve form dolduruldu:', vehicle);

            } else {
                setChassisSearchError('Bu şase numarasına ait araç bulunamadı');
                setFoundVehicle(null);
            }

        } catch (error) {
            console.error('Araç arama hatası:', error);

            if (error.response?.status === 404) {
                setChassisSearchError('Bu şase numarasına ait araç bulunamadı');
            } else if (error.response?.status === 403) {
                setChassisSearchError('Bu işlem için yetkiniz bulunmuyor');
            } else {
                setChassisSearchError('Araç aranırken hata oluştu. Lütfen tekrar deneyin.');
            }

            setFoundVehicle(null);
        } finally {
            setSearchingVehicle(false);
        }
    };

    // *** Plaka ile araç arama fonksiyonu ***
    const handleSearchByPlate = async () => {
        if (!vehicleData.plate || vehicleData.plate.length < 5) {
            setPlateSearchError('Geçerli bir plaka numarası giriniz');
            return;
        }

        setSearchingByPlate(true);
        setPlateSearchError('');
        setError('');
        setSuccess('');

        try {
            console.log(`🚗 Plaka ile araç aranıyor: ${vehicleData.plate}`);

            const response = await api.get(`/vehicles/search/plate/${vehicleData.plate}`);

            if (response.data.success && response.data.vehicles.length > 0) {
                const vehicle = response.data.vehicles[0];
                setFoundVehicle(vehicle);

                // Araç bilgilerini otomatik doldur
                setVehicleData(prev => ({
                    ...prev,
                    make: vehicle.brand || prev.make,
                    model: vehicle.model || prev.model,
                    saseNo: vehicle.chassisNumber || prev.saseNo,
                   // motorNo: vehicle.engineNumber || prev.motorNo,
                    price: vehicle.purchasePrice || prev.price,
                    tramer: vehicle.hasTramer ? 'VAR' : 'YOK',
                    tramerAmount: vehicle.tramerAmount || 0,
                    tramerDescription: vehicle.tramerDescription || ''
                }));

                // Formatlanmış fiyatları güncelle
                if (vehicle.purchasePrice > 0) {
                    setFormattedPrice(formatNumber(vehicle.purchasePrice));
                }
                if (vehicle.tramerAmount > 0) {
                    setFormattedTramerAmount(formatNumber(vehicle.tramerAmount));
                }

                setSuccess(`🚗 ${vehicle.brand} ${vehicle.model} (${vehicle.plateNumber}) aracı bulundu! Status: ${vehicle.status.toUpperCase()}`);
            } else {
                setPlateSearchError('Bu plaka numarasına ait araç bulunamadı');
                setFoundVehicle(null);
            }

        } catch (error) {
            console.error('Araç arama hatası:', error);
            if (error.response?.status === 404) {
                setPlateSearchError('Bu plaka numarasına ait araç bulunamadı');
            } else {
                setPlateSearchError('Araç aranırken hata oluştu. Lütfen tekrar deneyin.');
            }
            setFoundVehicle(null);
        } finally {
            setSearchingByPlate(false);
        }
    };

    // *** YENİ: TCKN/VKN ile customer arama fonksiyonu ***
    const handleSearchCustomer = async () => {
        if (!customerData.tcNo || customerData.tcNo.length < 10) {
            setCustomerSearchError('Geçerli bir kimlik numarası giriniz');
            return;
        }

        setSearchingCustomer(true);
        setCustomerSearchError('');
        setError('');
        setSuccess('');

        try {
            console.log(`👤 Customer aranıyor: ${customerData.tcNo} (${identityType})`);

            const response = await api.get(`/customers/search/${customerData.tcNo}?role=customer`);

            if (response.data.success && response.data.customers.length > 0) {
                const customer = response.data.customers[0];
                setFoundCustomer(customer);

                // Customer bilgilerini otomatik doldur
                setCustomerData(prev => ({
                    ...prev,
                    name: customer.name || prev.name,
                    phone: customer.phone || prev.phone,
                    email: customer.email || prev.email,
                    address: customer.address || prev.address
                }));

                setSuccess(`👤 ${customer.name} müşterisi bulundu ve bilgiler otomatik dolduruldu!`);
                console.log('✅ Customer bulundu ve form dolduruldu:', customer);

            } else {
                setCustomerSearchError('Bu kimlik numarasına ait müşteri bulunamadı');
                setFoundCustomer(null);
            }

        } catch (error) {
            console.error('Customer arama hatası:', error);

            if (error.response?.status === 404) {
                setCustomerSearchError('Bu kimlik numarasına ait müşteri bulunamadı');
            } else if (error.response?.status === 403) {
                setCustomerSearchError('Bu işlem için yetkiniz bulunmuyor');
            } else {
                setCustomerSearchError('Müşteri aranırken hata oluştu. Lütfen tekrar deneyin.');
            }

            setFoundCustomer(null);
        } finally {
            setSearchingCustomer(false);
        }
    };

    // Formatlanmış input değişikliklerini handle et
    const handleFormattedNumberChange = (field, value) => {
        const cleanValue = value.replace(/[^\d]/g, '');

        if (cleanValue === '') {
            if (field === 'price') {
                setFormattedPrice('0');
                setVehicleData(prev => ({ ...prev, price: 0 }));
            } else if (field === 'downPayment') {
                setFormattedDownPayment('0');
                setFinancialData(prev => ({ ...prev, downPayment: 0 }));
            } else if (field === 'tramerAmount') {
                setFormattedTramerAmount('0');
                setVehicleData(prev => ({ ...prev, tramerAmount: 0 }));
            } else if (field === 'kaskoBedeli') {
                setFormattedKaskoBedeli('0');
                setKaskoBedeli(0);
            }
            return;
        }

        const numericValue = parseInt(cleanValue, 10);
        const formatted = formatNumber(numericValue);

        if (field === 'price') {
            setFormattedPrice(formatted);
            setVehicleData(prev => ({ ...prev, price: numericValue }));
        } else if (field === 'downPayment') {
            setFormattedDownPayment(formatted);
            setFinancialData(prev => ({ ...prev, downPayment: numericValue }));
        } else if (field === 'tramerAmount') {
            setFormattedTramerAmount(formatted);
            setVehicleData(prev => ({ ...prev, tramerAmount: numericValue }));
        } else if (field === 'kaskoBedeli') {
            setFormattedKaskoBedeli(formatted);
            setKaskoBedeli(numericValue);
        }
    };

    // *** GÜNCELLENEN: Müşteri verisi değişikliklerini handle et (TCKN/VKN desteği) ***
    const handleCustomerChange = (field, value) => {
        // Text alanları için büyük harf dönüşümü
        const upperCaseFields = ['name', 'address'];
        if (upperCaseFields.includes(field)) {
            value = value.toUpperCase();
        }

        // *** YENİ: Kimlik numarası için özel kontroller (TCKN/VKN) ***
        if (field === 'tcNo') {
            // Sadece sayı girişine izin ver
            if (value && !/^[0-9]+$/.test(value)) {
                return;
            }

            // Kimlik doğrulama hatasını sıfırla
            setTcError('');
            setIdentityError('');

            // *** YENİ: Customer search hatalarını da temizle ***
            setCustomerSearchError('');
            setFoundCustomer(null);

            // Uzunluk kontrolü - TCKN: 11, VKN: 10
            const maxLength = identityType === 'TCKN' ? 11 : 10;
            if (value.length > maxLength) {
                return;
            }

            // Tam uzunluğa ulaştığında doğrulama yap
            if (value.length === maxLength) {
                if (identityType === 'TCKN') {
                    if (!validateTCNumber(value)) {
                        setIdentityError('Geçersiz T.C. Kimlik Numarası');
                    }
                } else if (identityType === 'VKN') {
                    if (!validateVKNNumber(value)) {
                        setIdentityError('Geçersiz Vergi Kimlik Numarası');
                    }
                }
            }
        }

        // *** YENİ: Telefon numarası validasyonu ***
        if (field === 'phone') {
            // Sadece rakam ve + girişine izin ver
            if (value && !/^[0-9+\s\-\(\)]+$/.test(value)) {
                return;
            }

            // Phone error'ını temizle
            setPhoneError('');

            // 10+ karakter girildiyse validation yap
            if (value.length >= 10) {
                if (!validatePhoneNumber(value)) {
                    setPhoneError('Geçerli bir telefon numarası giriniz (örn: 05XXXXXXXXX)');
                }
            }
        }

        setCustomerData(prev => ({ ...prev, [field]: value }));
    };

    // *** YENİ: Kefil verisi değişikliklerini handle et ***
    const handleGuarantorChange = (field, value) => {
        // Text alanları için büyük harf dönüşümü
        const upperCaseFields = ['name', 'address'];
        if (upperCaseFields.includes(field)) {
            value = value.toUpperCase();
        }

        // TC No için özel kontroller
        if (field === 'tcNo') {
            // Sadece sayı girişine izin ver
            if (value && !/^[0-9]+$/.test(value)) {
                return;
            }

            // Kefil error'ını sıfırla
            setGuarantorError('');

            // Uzunluk kontrolü - TCKN: 11, VKN: 10
            const maxLength = guarantorData.identityType === 'TCKN' ? 11 : 10;
            if (value.length > maxLength) {
                return;
            }

            // Tam uzunluğa ulaştığında doğrulama yap
            if (value.length === maxLength) {
                if (guarantorData.identityType === 'TCKN') {
                    if (!validateTCNumber(value)) {
                        setGuarantorError('Geçersiz T.C. Kimlik Numarası');
                    }
                } else if (guarantorData.identityType === 'VKN') {
                    if (!validateVKNNumber(value)) {
                        setGuarantorError('Geçersiz Vergi Kimlik Numarası');
                    }
                }
            }
        }

        setGuarantorData(prev => ({ ...prev, [field]: value }));
    };

    // *** GÜNCELLENEN: Araç verisi değişikliklerini handle et (şase arama reset ekli) ***
    const handleVehicleChange = (field, value) => {
        const upperCaseFields = ['plate', 'saseNo'];
        if (upperCaseFields.includes(field)) {
            value = value.toUpperCase();
        }

        if (field === 'year') {
            value = parseInt(value) || 0;
        }

        // *** Şase no değiştiğinde bulunan aracı temizle ***
        if (field === 'saseNo') {
            setFoundVehicle(null);
            setChassisSearchError('');
        }

        // *** Plaka no değiştiğinde bulunan aracı temizle ***
        if (field === 'plate') {
            setFoundVehicle(null);
            setPlateSearchError('');
        }

        setVehicleData(prev => ({ ...prev, [field]: value }));
    };

    // Finansal veri değişikliklerini handle et
    const handleFinancialChange = (field, value) => {
        if (field === 'term') {
            value = parseInt(value) || 1;
        } else if (field === 'interestRate') {
            value = parseFloat(value) || 0;
        }

        setFinancialData(prev => ({ ...prev, [field]: value }));
    };

    // PMT fonksiyonu
    const calculatePMT = (rate, nper, pv) => {
        if (rate === 0) return pv / nper;

        const pvif = Math.pow(1 + rate, nper);
        const pmt = (rate * pv * pvif) / (pvif - 1);
        return pmt;
    };


    /**
     * ERTELEMELİ SENET HESAPLAMA - DURUM-2
     * ====================================
     * 
     * Bu fonksiyon müşterinin senet başlangıç tarihini normal başlangıç tarihi ile karşılaştırarak
     * erteleme gün sayısını ve gecikme faizini hesaplar.
     * 
     * MANTIK:
     * 1. Normal başlangıç tarihini hesapla (DURUM-1 mantığı: bugün + 1 ay + hafta sonu kontrolü)
     * 2. Seçilen tarih ile normal başlangıç arasındaki farkı bul
     * 3. Gecikme faizini hesapla (anapara × günlük faiz × erteleme günü)
     * 4. Yeni kredi tutarını hesapla (anapara + gecikme faizi)
     * 
     * ÖRNEK:
     * - Bugün: 14/8/2025
     * - Normal başlangıç: 14/9/2025 (hafta sonu kontrolü ile)
     * - Müşteri seçimi: 13/12/2025 (90 gün erteleme)
     * - Gecikme faizi: 650.000 × (5%/30) × 90 = 97.500 TL
     * - Yeni kredi: 650.000 + 97.500 = 747.500 TL
     */
    const calculateDeferredPeriod = () => {
        if (!senetBaslangicTarihi) {
            console.log('❌ Senet başlangıç tarihi yok');
            return { days: 0, months: 0, deferredInterest: 0, newLoanAmount: 0 };
        }

        console.log('🔄 DURUM-2 erteleme hesaplaması başlıyor...');

        const today = new Date();
        const selectedDate = new Date(senetBaslangicTarihi);

        // *** NORMAL BAŞLANGIÇ TARİHİNİ HESAPLA (DURUM-1 MANTIKLA) ***
        const normalStartDate = new Date(today);
        normalStartDate.setMonth(today.getMonth() + 1); // Bir sonraki aynı gün

        // Ay değişiminde gün sayısı kontrolü (31 Ocak → 28 Şubat gibi)
        const targetDay = today.getDate();
        if (normalStartDate.getDate() !== targetDay) {
            const lastDayOfMonth = new Date(normalStartDate.getFullYear(), normalStartDate.getMonth() + 1, 0).getDate();
            normalStartDate.setDate(Math.min(targetDay, lastDayOfMonth));
        }

        // Hafta sonu kontrolü (DURUM-1 mantığı)
        const originalNormalDate = new Date(normalStartDate);
        if (normalStartDate.getDay() === 0) { // Pazar
            normalStartDate.setDate(normalStartDate.getDate() + 1); // Pazartesi'ye AT
            console.log(`📅 Normal başlangıç: ${originalNormalDate.toISOString().split('T')[0]} (Pazar) → ${normalStartDate.toISOString().split('T')[0]} (Pazartesi)`);
        } else if (normalStartDate.getDay() === 6) { // Cumartesi
            normalStartDate.setDate(normalStartDate.getDate() - 1); // Cuma'ya ÇEK
            console.log(`📅 Normal başlangıç: ${originalNormalDate.toISOString().split('T')[0]} (Cumartesi) → ${normalStartDate.toISOString().split('T')[0]} (Cuma)`);
        } else {
            console.log(`📅 Normal başlangıç: ${normalStartDate.toISOString().split('T')[0]} (${['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'][normalStartDate.getDay()]})`);
        }

        // *** ERTELEME GÜN SAYISINI HESAPLA ***
        const diffTime = selectedDate.getTime() - normalStartDate.getTime();
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        console.log('📊 Tarih karşılaştırması:', {
            normalStartDate: normalStartDate.toISOString().split('T')[0],
            selectedDate: selectedDate.toISOString().split('T')[0],
            diffDays: diffDays
        });

        // Eğer seçili tarih normal başlangıçtan önce/aynıysa erteleme yok
        if (diffDays <= 0) {
            console.log('✅ Erteleme yok - Normal senet');
            return { days: 0, months: 0, deferredInterest: 0, newLoanAmount: 0 };
        }

        // Maximum 90 gün erteleme
        const ertelemeDays = Math.min(diffDays, 90);

        // *** GECİKME FAİZİNİ HESAPLA ***
        const loanAmount = vehicleData.price - financialData.downPayment;
        const monthlyInterestRate = financialData.interestRate / 100;
        const dailyInterestRate = monthlyInterestRate / 30;
        const deferredInterest = loanAmount * dailyInterestRate * ertelemeDays;
        const newLoanAmount = loanAmount + deferredInterest;

        console.log('💰 Erteleme finansal hesaplama:', {
            originalLoanAmount: loanAmount,
            monthlyInterestRate: `${financialData.interestRate}%`,
            dailyInterestRate: `${(dailyInterestRate * 100).toFixed(4)}%`,
            ertelemeDays: ertelemeDays,
            deferredInterest: Math.round(deferredInterest),
            newLoanAmount: Math.round(newLoanAmount)
        });

        const result = {
            days: ertelemeDays,
            months: Math.floor(ertelemeDays / 30),
            deferredInterest: Math.round(deferredInterest),
            newLoanAmount: Math.round(newLoanAmount)
        };

        console.log('✅ DURUM-2 erteleme hesaplama tamamlandı:', result);
        return result;
    };

    /**
     * FİNANSAL HESAPLAMA - DURUM-1 (Normal) + DURUM-2 (Ertelemeli)
     * =============================================================
     * 
     * Bu fonksiyon otomatik olarak erteleme kontrolü yapar ve uygun hesaplama tipini uygular:
     * 
     * DURUM-1 (Normal Senet):
     * - Erteleme yok (0 gün)
     * - Normal PMT hesaplaması
     * - "Ertelemeli Ödeme" uyarısı gösterilmez
     * 
     * DURUM-2 (Ertelemeli Senet):
     * - X gün erteleme var
     * - Gecikme faizi eklenir (anapara × günlük faiz × erteleme günü)
     * - Yeni kredi tutarı üzerinden PMT hesaplaması
     * - "X Gün Ertelemeli Ödeme" uyarısı gösterilir
     * 
     * Müşteri tarafından seçilen senet başlangıç tarihine göre otomatik algılama yapar.
     */

    // ReportGeneratorPage.js içindeki calculateFinancials fonksiyonunu BU KODLA DEĞİŞTİR:

    const calculateFinancials = () => {
        console.log('💰 Finansal hesaplama başlıyor (DURUM-1/DURUM-2 otomatik algılama)...');

        const kaskoTutari = kaskoYapildi ? kaskoBedeli : 0;
        const baseLoanAmount = vehicleData.price - financialData.downPayment + kaskoTutari;

        if (baseLoanAmount <= 0 || financialData.term <= 0) {
            setCalculations(null);
            console.log('❌ Geçersiz kredi tutarı veya vade');
            return;
        }

        const monthlyInterestRate = financialData.interestRate / 100;

        // *** ERTELEME KONTROLÜ - OTOMATIK DURUM ALGILLAMA ***
        const deferredInfo = calculateDeferredPeriod();

        console.log('🔍 Durum algılama sonucu:', deferredInfo);

        let finalLoanAmount = baseLoanAmount;
        let isDeferred = false;
        let deferredDays = 0;

        if (deferredInfo.days > 0) {
            // *** DURUM-2: ERTELEMELİ SENET ***
            console.log(`🔄 DURUM-2 tespit edildi: ${deferredInfo.days} gün erteleme`);

            finalLoanAmount = deferredInfo.newLoanAmount; // Gecikme faizi eklenmiş tutar
            isDeferred = true;
            deferredDays = deferredInfo.days;

            console.log('💸 Ertelemeli finansal detaylar:', {
                originalLoanAmount: baseLoanAmount,
                deferredInterest: deferredInfo.deferredInterest,
                finalLoanAmount: finalLoanAmount,
                deferredDays: deferredDays
            });
        } else {
            // *** DURUM-1: NORMAL SENET ***
            console.log('✅ DURUM-1 tespit edildi: Normal senet (erteleme yok)');

            finalLoanAmount = baseLoanAmount; // Değişiklik yok
            isDeferred = false;
            deferredDays = 0;
        }

        // *** PMT HESAPLAMASI (Her iki durum için ortak) ***
        const monthlyPayment = calculatePMT(monthlyInterestRate, financialData.term, finalLoanAmount);
        const totalPayment = monthlyPayment * financialData.term;
        const totalInterest = totalPayment - baseLoanAmount; // Not: Base loan amount kullanıyoruz

        console.log('📊 Final hesaplama sonuçları:', {
            finalLoanAmount: Math.round(finalLoanAmount),
            monthlyPayment: Math.round(monthlyPayment),
            totalPayment: Math.round(totalPayment),
            totalInterest: Math.round(totalInterest),
            isDeferred: isDeferred,
            deferredDays: deferredDays
        });

        // *** UI İÇİN VERİ HAZIRLA ***
        setCalculations({
            loanAmount: Math.round(baseLoanAmount),        // Orijinal kredi tutarı (UI için)
            finalLoanAmount: Math.round(finalLoanAmount),  // Erteleme faizi dahil tutar
            monthlyPayment: Math.round(monthlyPayment),
            totalPayment: Math.round(totalPayment),
            totalInterest: Math.round(totalInterest),
            deferredDays: deferredDays,                    // *** UI UYARISI İÇİN ***
            isDeferred: isDeferred,                        // *** UI UYARISI İÇİN ***
            // Erteleme detayları
            deferredInterest: deferredInfo.deferredInterest || 0
        });

        const durumText = isDeferred ? `DURUM-2 (${deferredDays} gün ertelemeli)` : 'DURUM-1 (normal)';
        console.log(`✅ ${durumText} finansal hesaplama tamamlandı`);
    };

    useEffect(() => {
        if (vehicleData.price > 0 && financialData.downPayment >= 0 && financialData.term > 0) {
            calculateFinancials();
        } else {
            setCalculations(null);
        }
    }, [vehicleData.price, financialData.downPayment, financialData.term, financialData.interestRate, senetBaslangicTarihi, kaskoYapildi, kaskoBedeli]);

    useEffect(() => {
        setFormattedPrice(formatNumber(vehicleData.price));
        setFormattedDownPayment(formatNumber(financialData.downPayment));
        setFormattedTramerAmount(formatNumber(vehicleData.tramerAmount));
    }, []);

    const handleConfirmSubmit = () => {
        setShowConfirmModal(false);
        handleActualSubmit();
    };

    /**
     * FİNANSMAL RAPOR OLUŞTURMA - ERTELEMELİ SENET DESTEĞİ İLE
     * ========================================================
     * 
     * Bu fonksiyon müşteri sözleşme formunu backend'e göndermeden önce
     * erteleme hesaplamalarını yapar ve frontend'teki hesaplanan değerleri
     * backend'e aktarır.
     * 
     * ÖNCEKI PROBLEM:
     * - Frontend doğru hesaplıyor (650.000 → 747.500 TL)
     * - Backend frontend'teki hesaplamaları almıyor
     * - Word belgesi yanlış tutarlarla oluşuyor (650.000 TL)
     * 
     * ÇÖZÜM:
     * - calculateDeferredPeriod() ile erteleme bilgilerini hesapla
     * - calculatePMT() ile ertelemeli tutar üzerinden taksit hesapla  
     * - Bu hesaplanan değerleri requestData'ya ekle
     * - Backend bu hazır değerleri alıp Word belgesinde kullanacak
     * 
     * DURUM-1: Normal senet (erteleme yok) → orijinal kredi tutarı
     * DURUM-2: Ertelemeli senet → kredi + gecikme faizi tutarı
     */
    const handleActualSubmit = async () => {
        setLoading(true);
        setError('');
        setSuccess('');

        try {
            console.log('🚀 Form submit başladı');

            // *** YENİ: Erteleme hesaplamalarını yap ***
            const deferredInfo = calculateDeferredPeriod();
            console.log('📊 Erteleme bilgileri hesaplandı:', deferredInfo);

            // *** YENİ: Final finansal tutarları hesapla ***
            const kaskoTutari = kaskoYapildi ? kaskoBedeli : 0;
            const baseLoanAmount = vehicleData.price - financialData.downPayment + kaskoTutari;

            let finalLoanAmount = baseLoanAmount;
            let isDeferred = false;

            if (deferredInfo.days > 0) {
                finalLoanAmount = deferredInfo.newLoanAmount;
                isDeferred = true;
                console.log(`🔄 Ertelemeli senet: ${deferredInfo.days} gün, Yeni tutar: ${finalLoanAmount}`);
            } else {
                console.log('✅ Normal senet: Erteleme yok');
            }

            // *** YENİ: Monthly payment hesapla (ertelemeli tutar üzerinden) ***
            const monthlyInterestRate = financialData.interestRate / 100;
            const monthlyPayment = calculatePMT(monthlyInterestRate, financialData.term, finalLoanAmount);

            // *** YENİ: Kimlik numarası doğrulama kontrolü (TCKN/VKN) ***
            if (customerData.tcNo) {
                if (identityType === 'TCKN') {
                    if (!validateTCNumber(customerData.tcNo)) {
                        setIdentityError('Geçersiz T.C. Kimlik Numarası');
                        setError('Lütfen geçerli bir T.C. Kimlik Numarası giriniz.');
                        setLoading(false);
                        return;
                    }
                } else if (identityType === 'VKN') {
                    if (!validateVKNNumber(customerData.tcNo)) {
                        setIdentityError('Geçersiz Vergi Kimlik Numarası');
                        setError('Lütfen geçerli bir Vergi Kimlik Numarası giriniz.');
                        setLoading(false);
                        return;
                    }
                }
            }

            console.log(`✅ ${identityType} doğrulandı`);

            // Client-side validation
            const errors = [];

            if (!customerData.name || customerData.name.trim().length < 2) {
                errors.push('Müşteri adı en az 2 karakter olmalıdır');
            }

            if (!customerData.phone || customerData.phone.trim().length < 10) {
                errors.push('Telefon numarası gereklidir');
            } else if (!validatePhoneNumber(customerData.phone)) {
                errors.push('Geçerli bir telefon numarası giriniz');
            }

            if (!vehicleData.make || vehicleData.make.trim().length < 2) {
                errors.push('Araç markası gereklidir');
            }

            if (!vehicleData.model || vehicleData.model.trim().length < 2) {
                errors.push('Araç modeli gereklidir');
            }

            if (!vehicleData.price || vehicleData.price <= 0) {
                errors.push('Araç fiyatı geçerli bir değer olmalıdır');
            }

            if (!vehicleData.plate || vehicleData.plate.trim().length < 5) {
                errors.push('Plaka gereklidir');
            }

            if (!vehicleData.saseNo || vehicleData.saseNo.trim().length !== 17) {
                errors.push('Şase numarası 17 haneli olmalıdır');
            } else if (!/^[A-HJ-NPR-Z0-9]+$/i.test(vehicleData.saseNo)) {
                errors.push('Şase numarası sadece harf ve rakam içerebilir (I, O, Q harfleri hariç)');
            }

            // *** YENİ: Kefil validation (eğer kefil varsa) ***
            if (hasGuarantor) {
                if (!guarantorData.name || guarantorData.name.trim().length < 2) {
                    errors.push('Kefil adı en az 2 karakter olmalıdır');
                }

                // Kimlik türüne göre validation
                const expectedLength = guarantorData.identityType === 'TCKN' ? 11 : 10;
                if (!guarantorData.tcNo || guarantorData.tcNo.length !== expectedLength) {
                    errors.push(`Kefil ${guarantorData.identityType} ${expectedLength} haneli olmalıdır`);
                } else {
                    if (guarantorData.identityType === 'TCKN') {
                        if (!validateTCNumber(guarantorData.tcNo)) {
                            errors.push('Geçerli bir kefil T.C. Kimlik No giriniz');
                        }
                    } else if (guarantorData.identityType === 'VKN') {
                        if (!validateVKNNumber(guarantorData.tcNo)) {
                            errors.push('Geçerli bir kefil Vergi Kimlik No giriniz');
                        }
                    }
                }

                if (!guarantorData.address || guarantorData.address.trim().length < 5) {
                    errors.push('Kefil adresi en az 5 karakter olmalıdır');
                }
            }

            if (financialData.downPayment < 0) {
                errors.push('Peşin ödeme negatif olamaz');
            }

            if (!financialData.interestRate || financialData.interestRate <= 0 || financialData.interestRate > 100) {
                errors.push('Faiz oranı 0-100 arasında olmalıdır');
            }

            if (!financialData.term || financialData.term < 1 || financialData.term > 120) {
                errors.push('Vade süresi 1-120 ay arasında olmalıdır');
            }

            if (!senetBaslangicTarihi) {
                errors.push('Senet başlangıç tarihi gereklidir');
            } else {
                const senetDate = new Date(senetBaslangicTarihi);
                const today = new Date();
                if (senetDate < today) {
                    errors.push('Senet başlangıç tarihi bugünden önce olamaz');
                }
            }

            // Tramer kontrolü
            if (vehicleData.tramer === 'VAR') {
                if (!vehicleData.tramerAmount || vehicleData.tramerAmount <= 0) {
                    errors.push('Tramer varsa tutarı girilmelidir');
                }
                if (!vehicleData.tramerDescription || vehicleData.tramerDescription.trim().length < 5) {
                    errors.push('Tramer açıklaması gereklidir');
                }
            }

            if (errors.length > 0) {
                console.error('⌛ Client-side validation errors:', errors);
                setError(errors.join(', '));
                setLoading(false);
                return;
            }

            console.log('✅ Client-side validation passed');

            // *** GÜNCELLENMİŞ: Backend'in beklediği format (ERTELEMELİ VERİLER DAHİL) ***
            const requestData = {
                customerData: {
                    name: customerData.name.trim(),
                    tcNo: customerData.tcNo.trim(),
                    phone: customerData.phone.trim(),
                    email: customerData.email.trim(),
                    address: customerData.address.trim(),
                    vehicleStatus: foundVehicle?.status || 'active',
                },
                // Kimlik türünü ekle
                identityType: identityType,
                // Active tab bilgisini backend'e gönder
                activeTab: activeTab,

                vehicleData: {
                    make: vehicleData.make.trim(),
                    model: vehicleData.model.trim(),
                    plate: vehicleData.plate.trim(),
                    price: vehicleData.price,
                    saseNo: vehicleData.saseNo.trim(),
                    tramer: vehicleData.tramer,
                    tramerAmount: vehicleData.tramerAmount || 0,
                    tramerDescription: vehicleData.tramerDescription.trim()
                },
                financialData: {
                    downPayment: financialData.downPayment,
                    interestRate: financialData.interestRate,
                    term: financialData.term,
                    // *** YENİ: Hesaplanan değerler ***
                    loanAmount: baseLoanAmount,
                    finalLoanAmount: finalLoanAmount, // *** Erteleme faizi dahil tutar ***
                    monthlyPayment: monthlyPayment,
                    totalPayment: monthlyPayment * financialData.term,
                    totalInterest: (monthlyPayment * financialData.term) - baseLoanAmount,
                    // *** YENİ: Kasko bilgileri ***
                    kaskoYapildi: kaskoYapildi,
                    kaskoBedeli: kaskoYapildi ? kaskoBedeli : 0
                },
                senetBaslangicTarihi: senetBaslangicTarihi,
                notes: notes.trim(),
                // Kefil bilgileri (opsiyonel)
                guarantorData: hasGuarantor ? {
                    name: guarantorData.name.trim(),
                    tcNo: guarantorData.tcNo.trim(),
                    address: guarantorData.address.trim(),
                    identityType: guarantorData.identityType // *** YENİ: Kefil kimlik türü ***
                } : null,
                hasGuarantor: hasGuarantor,
                // Vehicle ID ekleme (stok düşürme için)
                vehicleId: foundVehicle?._id || null,

                // *** YENİ: ERTELEMELİ SENET BİLGİLERİ ***
                deferredInfo: {
                    isDeferred: isDeferred,
                    days: deferredInfo.days,
                    months: deferredInfo.months,
                    deferredInterest: deferredInfo.deferredInterest,
                    newLoanAmount: deferredInfo.newLoanAmount
                }
            };

            console.log('📤 Gönderilecek veri (erteleme dahil):', JSON.stringify(requestData, null, 2));

            // Token kontrol
            const token = localStorage.getItem('token');
            console.log('🔑 Token:', token ? 'Token mevcut' : 'Token yok');

            if (!token) {
                setError('Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.');
                setLoading(false);
                navigate('/login');
                return;
            }

            // API çağrısı
            const response = await api.post('/reports', requestData);

            console.log('✅ API yanıtı:', response.data);

            if (response.data.success) {
               setSuccess('Rapor başarıyla oluşturuldu! Stok ve başvuru durumu güncellendi.');
                setTimeout(() => {
                    navigate('/reports');
                }, 1500);
            } else {
                throw new Error(response.data.message || 'Bilinmeyen hata');
            }

        } catch (error) {
            console.error('🚨 API hatası:', error);

            let errorMessage = 'Rapor oluşturulurken hata oluştu';

            if (error.response) {
                console.log('📊 Response Status:', error.response.status);
                console.log('📋 Response Data:', error.response.data);

                if (error.response.data.errors && Array.isArray(error.response.data.errors)) {
                    errorMessage = error.response.data.errors.join(', ');
                } else if (error.response.data.message) {
                    errorMessage = error.response.data.message;
                } else if (error.response.status === 400) {
                    errorMessage = 'Girilen bilgilerde hata var. Lütfen kontrol edin.';
                } else if (error.response.status === 401) {
                    errorMessage = 'Oturum süreniz dolmuş. Lütfen tekrar giriş yapın.';
                    navigate('/login');
                    return;
                } else if (error.response.status === 403) {
                    errorMessage = 'Bu işlem için yetkiniz yok.';
                }
            } else if (error.request) {
                console.log('📡 İstek yapıldı ama yanıt alınamadı');
                errorMessage = 'Sunucuya bağlanılamadı. Lütfen internet bağlantınızı kontrol edin.';
            } else {
                console.log('⚠️ Hata mesajı:', error.message);
                errorMessage = error.message;
            }

            setError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return (
         <>
        <Container className="py-5">
            <Row className="mb-4">
                <Col>
                    <h1 className="text-center">Finansman Raporu Oluştur</h1>
                    <p className="text-center text-muted">
                        Müşteri ve araç bilgilerini girerek detaylı finansman raporu oluşturun
                    </p>
                </Col>
            </Row>

            {error && <Alert variant="danger">{error}</Alert>}
            {success && <Alert variant="success">{success}</Alert>}

            <Form onSubmit={(e) => e.preventDefault()}>
                {/* *** YENİ: Tab Sistemi *** */}
                <Row className="mb-3">
                    <Col md={8} className="offset-md-2">
                        <div className="d-flex gap-3 justify-content-center">
                            <Button
                                variant={activeTab === 'stock' ? 'primary' : 'outline-primary'}
                                onClick={() => setActiveTab('stock')}
                                className="px-4"
                            >
                                🏪 Stok Araç
                            </Button>
                            <Button
                                variant={activeTab === 'external' ? 'primary' : 'outline-primary'}
                                onClick={() => setActiveTab('external')}
                                className="px-4"
                            >
                                🔄 Harici Araç
                            </Button>
                        </div>
                        <div className="text-center mt-2">
                            <small className="text-muted">
                                {activeTab === 'stock'
                                    ? 'Galerideki mevcut araçlar için kullanın'
                                    : 'Başka galeriden alınacak araçlar için kullanın'
                                }
                            </small>
                        </div>
                    </Col>
                </Row>

                <Row>
                    {/* Müşteri Bilgileri */}
                    <Col md={4}>
                        <Card className="mb-4">
                            <Card.Header>
                                <h5 className="mb-0">Müşteri Bilgileri</h5>
                            </Card.Header>
                            <Card.Body>
                                <Form.Group className="mb-3">
                                    <Form.Label>Ad Soyad *</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={customerData.name}
                                        onChange={(e) => handleCustomerChange('name', e.target.value)}
                                        required
                                    />
                                </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Telefon *</Form.Label>
                                        <Form.Control
                                            type="tel"
                                            value={customerData.phone}
                                            onChange={(e) => handleCustomerChange('phone', e.target.value)}
                                            className={phoneError ? "is-invalid" : ""}
                                            placeholder="05XXXXXXXXX"
                                            required
                                        />
                                        {phoneError && (
                                            <div className="invalid-feedback">
                                                {phoneError}
                                            </div>
                                        )}
                                        <Form.Text className="text-muted">
                                            Türkiye telefon numarası formatında giriniz
                                        </Form.Text>
                                    </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        value={customerData.email}
                                        onChange={(e) => handleCustomerChange('email', e.target.value)}
                                    />
                                </Form.Group>

                                {/* *** YENİ: Kimlik Türü Seçimi *** */}
                                <Form.Group className="mb-3">
                                    <Form.Label className="fw-bold">Kimlik Türü *</Form.Label>
                                    <div className="d-flex gap-3 mt-2">
                                        <Form.Check
                                            type="radio"
                                            id="identity-tckn"
                                            name="identityType"
                                            label="T.C. Kimlik No"
                                            checked={identityType === 'TCKN'}
                                            onChange={() => handleIdentityTypeChange('TCKN')}
                                        />
                                        <Form.Check
                                            type="radio"
                                            id="identity-vkn"
                                            name="identityType"
                                            label="Vergi Kimlik No"
                                            checked={identityType === 'VKN'}
                                            onChange={() => handleIdentityTypeChange('VKN')}
                                        />
                                    </div>
                                </Form.Group>

                                {/* *** GÜNCELLENEN: Kimlik No Input (TCKN/VKN dynamic + Search) *** */}
                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        {identityType === 'TCKN' ? 'T.C. Kimlik No' : 'Vergi Kimlik No'} *
                                    </Form.Label>
                                    <div className="d-flex gap-2">
                                        <Form.Control
                                            type="text"
                                            value={customerData.tcNo}
                                            onChange={(e) => handleCustomerChange('tcNo', e.target.value)}
                                            maxLength={identityType === 'TCKN' ? 11 : 10}
                                            placeholder={identityType === 'TCKN' ? '12345678901 (11 hane)' : '1234567890 (10 hane)'}
                                            className={identityError || tcError || customerSearchError ? "is-invalid" : ""}
                                            required
                                        />
                                        <Button
                                            variant="outline-primary"
                                            onClick={handleSearchCustomer}
                                            disabled={customerData.tcNo.length < 10 || searchingCustomer}
                                            title="Bu kimlik ile müşteri ara"
                                        >
                                            {searchingCustomer ? (
                                                <Spinner size="sm" animation="border" />
                                            ) : (
                                                <FaSearch />
                                            )}
                                        </Button>
                                    </div>
                                    {(identityError || tcError || customerSearchError) && (
                                        <div className="invalid-feedback">
                                            {identityError || tcError || customerSearchError}
                                        </div>
                                    )}
                                    <Form.Text className="text-muted">
                                        {identityType === 'TCKN'
                                            ? 'T.C. Kimlik Numarası 11 haneli olmalıdır'
                                            : 'Vergi Kimlik Numarası 10 haneli olmalıdır'
                                        }
                                    </Form.Text>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Adres*</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={customerData.address}
                                        onChange={(e) => handleCustomerChange('address', e.target.value)}
                                        required
                                    />
                                </Form.Group>
                            </Card.Body>
                        </Card>
                        {/* *** YENİ: Kefil Bilgileri Card *** */}
                        <Card className="mb-4">
                            <Card.Header className="d-flex justify-content-between align-items-center">
                                <h6 className="mb-0">Kefil Bilgileri (Opsiyonel)</h6>
                                <Form.Check
                                    type="switch"
                                    id="guarantor-switch"
                                    label="Kefil var"
                                    checked={hasGuarantor}
                                    onChange={(e) => {
                                        setHasGuarantor(e.target.checked);
                                        if (!e.target.checked) {
                                            // Kefil bilgilerini temizle
                                            setGuarantorData({ name: '', tcNo: '', address: '' });
                                            setGuarantorError('');
                                        }
                                    }}
                                />
                            </Card.Header>
                            {hasGuarantor && (
                                <Card.Body>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-bold">Kefil Kimlik Türü *</Form.Label>
                                        <div className="d-flex gap-3 mt-2">
                                            <Form.Check
                                                type="radio"
                                                id="guarantor-identity-tckn"
                                                name="guarantorIdentityType"
                                                label="T.C. Kimlik No"
                                                checked={guarantorData.identityType === 'TCKN'}
                                                onChange={() => {
                                                    setGuarantorData(prev => ({
                                                        ...prev,
                                                        identityType: 'TCKN',
                                                        tcNo: '' // Kimlik türü değiştiğinde temizle
                                                    }));
                                                    setGuarantorError('');
                                                }}
                                            />
                                            <Form.Check
                                                type="radio"
                                                id="guarantor-identity-vkn"
                                                name="guarantorIdentityType"
                                                label="Vergi Kimlik No"
                                                checked={guarantorData.identityType === 'VKN'}
                                                onChange={() => {
                                                    setGuarantorData(prev => ({
                                                        ...prev,
                                                        identityType: 'VKN',
                                                        tcNo: '' // Kimlik türü değiştiğinde temizle
                                                    }));
                                                    setGuarantorError('');
                                                }}
                                            />
                                        </div>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Kefil Adı Soyadı *</Form.Label>                                        <Form.Control
                                            type="text"
                                            value={guarantorData.name}
                                            onChange={(e) => handleGuarantorChange('name', e.target.value)}
                                            placeholder="Kefil adı soyadı"
                                            required={hasGuarantor}
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>
                                            {guarantorData.identityType === 'TCKN' ? 'Kefil T.C. Kimlik No' : 'Kefil Vergi Kimlik No'} *
                                        </Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={guarantorData.tcNo}
                                            onChange={(e) => handleGuarantorChange('tcNo', e.target.value)}
                                            maxLength={guarantorData.identityType === 'TCKN' ? 11 : 10}
                                            placeholder={guarantorData.identityType === 'TCKN' ? '12345678901 (11 hane)' : '1234567890 (10 hane)'}
                                            className={guarantorError ? "is-invalid" : ""}
                                            required={hasGuarantor}
                                        />
                                        {guarantorError && (
                                            <div className="invalid-feedback">
                                                {guarantorError}
                                            </div>
                                        )}
                                        <Form.Text className="text-muted">
                                            T.C. Kimlik Numarası 11 haneli olmalıdır
                                        </Form.Text>
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Kefil Adresi *</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={2}
                                            value={guarantorData.address}
                                            onChange={(e) => handleGuarantorChange('address', e.target.value)}
                                            placeholder="Kefil adresi"
                                            required={hasGuarantor}
                                        />
                                    </Form.Group>

                                    <Alert variant="info" className="mb-0">
                                        <small>
                                            <strong>💡 Bilgi:</strong> Kefil bilgileri sözleşme ve senet belgelerinde kullanılacaktır.
                                        </small>
                                    </Alert>
                                </Card.Body>
                            )}
                        </Card>
                    </Col>
                    {/* Araç Bilgileri */}
                    <Col md={4}>
                        <Card className="mb-4">
                            <Card.Header>
                                <h5 className="mb-0">Araç Bilgileri</h5>
                            </Card.Header>
                            <Card.Body>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Marka *</Form.Label>
                                        {activeTab === 'stock' ? (
                                            <Form.Control
                                                type="text"
                                                value={vehicleData.make}
                                                onChange={(e) => handleVehicleChange('make', e.target.value)}
                                                disabled={true}
                                                className="bg-light"
                                                required
                                            />
                                        ) : (
                                            <Form.Select
                                                value={vehicleData.make}
                                                onChange={(e) => {
                                                    handleVehicleChange('make', e.target.value);
                                                    // Marka değiştiğinde modeli sıfırla
                                                    handleVehicleChange('model', '');
                                                }}
                                                disabled={loadingBrands}
                                                required
                                            >
                                                <option value="">Marka Seçiniz</option>
                                                {vehicleBrands.map((brand, index) => (
                                                    <option key={index} value={brand}>
                                                        {brand}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        )}
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Model *</Form.Label>
                                        {activeTab === 'stock' ? (
                                            <Form.Control
                                                type="text"
                                                value={vehicleData.model}
                                                onChange={(e) => handleVehicleChange('model', e.target.value)}
                                                disabled={true}
                                                className="bg-light"
                                                required
                                            />
                                        ) : (
                                            <Form.Select
                                                value={vehicleData.model}
                                                onChange={(e) => handleVehicleChange('model', e.target.value)}
                                                disabled={loadingModels || !vehicleData.make}
                                                required
                                            >
                                                <option value="">
                                                    {!vehicleData.make
                                                        ? "Önce marka seçiniz"
                                                        : loadingModels
                                                            ? "Modeller yükleniyor..."
                                                            : "Model Seçiniz"
                                                    }
                                                </option>
                                                {vehicleModels.map((model, index) => (
                                                    <option key={index} value={model.name}>
                                                        {model.name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        )}
                                    </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Fiyat (TL) *</Form.Label>
                                    <div className="input-group">
                                        <span className="input-group-text">₺</span>
                                        <Form.Control
                                            type="text"
                                            value={formattedPrice}
                                            onChange={(e) => handleFormattedNumberChange('price', e.target.value)}
                                            placeholder="0"
                                            required
                                        />
                                    </div>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Plaka *</Form.Label>
                                    {activeTab === 'stock' ? (
                                        <div className="d-flex gap-2">
                                            <Form.Control
                                                type="text"
                                                value={vehicleData.plate}
                                                onChange={(e) => handleVehicleChange('plate', e.target.value)}
                                                placeholder="34ABC123"
                                                className={plateSearchError ? "is-invalid" : ""}
                                                required
                                            />
                                            <Button
                                                variant="outline-primary"
                                                onClick={handleSearchByPlate}
                                                disabled={vehicleData.plate.length < 5 || searchingByPlate}
                                                title="Bu plaka ile stoktaki araç ara"
                                            >
                                                {searchingByPlate ? (
                                                    <Spinner size="sm" animation="border" />
                                                ) : (
                                                    <FaSearch />
                                                )}
                                            </Button>
                                        </div>
                                    ) : (
                                        <Form.Control
                                            type="text"
                                            value={vehicleData.plate}
                                            onChange={(e) => handleVehicleChange('plate', e.target.value)}
                                            placeholder="34ABC123"
                                            required
                                        />
                                    )}
                                    {plateSearchError && (
                                        <div className="invalid-feedback">
                                            {plateSearchError}
                                        </div>
                                    )}
                                    <Form.Text className="text-muted">
                                        {activeTab === 'stock'
                                            ? 'Plaka girin ve 🔍 butonuna tıklayarak stoktaki aracı arayın'
                                            : 'Harici araç plakasını girin'
                                        }
                                    </Form.Text>
                                </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label>Şase No*</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={vehicleData.saseNo}
                                            onChange={(e) => handleVehicleChange('saseNo', e.target.value)}
                                            disabled={activeTab === 'stock'}
                                            className={activeTab === 'stock' ? 'bg-light' : ''}
                                            placeholder="17 haneli şase numarası"
                                            maxLength={17}
                                            required
                                        />
                                    </Form.Group>

                             
                                <Form.Group className="mb-3">
                                    <Form.Label>Tramer Kaydı</Form.Label>
                                    <Form.Select
                                            value={vehicleData.tramer}
                                            disabled={activeTab === 'stock'}
                                            className={activeTab === 'stock' ? 'bg-light' : ''}
                                        onChange={(e) => {
                                            const newTramerValue = e.target.value;
                                            handleVehicleChange('tramer', newTramerValue);

                                            if (newTramerValue === 'YOK') {
                                                setFormattedTramerAmount('0');
                                                setVehicleData(prev => ({
                                                    ...prev,
                                                    tramerAmount: 0,
                                                    tramerDescription: ''
                                                }));
                                            }
                                        }}
                                    >
                                        <option value="YOK">Yok</option>
                                        <option value="VAR">Var</option>
                                    </Form.Select>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Tramer Tutarı (TL)</Form.Label>
                                        <div className="input-group">
                                            <span className="input-group-text">₺</span>
                                            <Form.Control
                                                type="text"
                                                value={formattedTramerAmount}
                                                onChange={(e) => handleFormattedNumberChange('tramerAmount', e.target.value)}
                                                placeholder="0"
                                                readOnly={vehicleData.tramer === 'YOK' || activeTab === 'stock'}
                                                className={vehicleData.tramer === 'YOK' || activeTab === 'stock' ? 'bg-light' : ''}
                                                required={vehicleData.tramer === 'VAR'}
                                            />
                                        </div>
                                    {vehicleData.tramer === 'YOK' && (
                                        <Form.Text className="text-muted">
                                            Tramer kaydı olmadığı için tutar 0 TL'dir.
                                        </Form.Text>
                                    )}
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>
                                        Tramer Açıklaması
                                        {vehicleData.tramer === 'VAR' && <span className="text-danger"> *</span>}
                                    </Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            value={vehicleData.tramerDescription}
                                            onChange={(e) => handleVehicleChange('tramerDescription', e.target.value)}
                                            placeholder={
                                                vehicleData.tramer === 'VAR'
                                                    ? "Aracın tramer durumu hakkında açıklama yazınız..."
                                                    : ""
                                            }
                                            readOnly={vehicleData.tramer === 'YOK' || activeTab === 'stock'}
                                            className={vehicleData.tramer === 'YOK' || activeTab === 'stock' ? 'bg-light' : ''}
                                            required={vehicleData.tramer === 'VAR'}
                                        />
                                    {vehicleData.tramer === 'YOK' ? (
                                        <Form.Text className="text-muted fst-italic small">
                                            Tramer kaydı olmadığı için açıklamaya gerek yok
                                        </Form.Text>
                                    ) : (
                                        <Form.Text className="text-muted">
                                            Tramer bilgileri giriniz. (Zorunlu alan)
                                        </Form.Text>
                                    )}
                                </Form.Group>

                                    {/* ✅ Araç Status Gösterimi (READ-ONLY) */}
                                    {activeTab === 'stock' && foundVehicle && (
                                        <Alert variant="success" className="mt-3">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div>
                                                    <strong>✅ Araç Bulundu!</strong><br />
                                                    <small className="text-muted">Stok sisteminden otomatik dolduruldu</small>
                                                </div>
                                                <Badge
                                                    bg={
                                                        foundVehicle.status === 'active' ? 'success' :
                                                            foundVehicle.status === 'reserved' ? 'warning' :
                                                                foundVehicle.status === 'sold' ? 'danger' : 'secondary'
                                                    }
                                                    className="fs-6 px-3 py-2"
                                                >
                                                    {foundVehicle.status?.toUpperCase()}
                                                </Badge>
                                            </div>
                                        </Alert>
                                    )}
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* Finansman Detayları */}
                    <Col md={4}>
                        <Card className="mb-4">
                            <Card.Header>
                                <h5 className="mb-0">Finansman Detayları</h5>
                            </Card.Header>
                            <Card.Body>
                                <Form.Group className="mb-3">
                                    <Form.Label>Peşinat (TL) *</Form.Label>
                                    <div className="input-group">
                                        <span className="input-group-text">₺</span>
                                        <Form.Control
                                            type="text"
                                            value={formattedDownPayment}
                                            onChange={(e) => handleFormattedNumberChange('downPayment', e.target.value)}
                                            placeholder="0"
                                            required
                                        />
                                    </div>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Vade (Ay) *</Form.Label>
                                    <Form.Control
                                        type="number"
                                        min="1"
                                        max="120"
                                        value={financialData.term}
                                        onChange={(e) => handleFinancialChange('term', e.target.value)}
                                        required
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Aylık Faiz Oranı (%) *</Form.Label>
                                    <div className="input-group">
                                        <Form.Control
                                            type="number"
                                            step="0.01"
                                            min="0.01"
                                            max="100"
                                            value={financialData.interestRate}
                                            onChange={(e) => handleFinancialChange('interestRate', e.target.value)}
                                            required
                                        />
                                            <span className="input-group-text">%</span>
                                        </div>
                                    </Form.Group>

                                    {/* *** YENİ: Kasko Checkbox ve Bedeli *** */}
                                    <Form.Group className="mb-3">
                                        <Form.Check
                                            type="checkbox"
                                            id="kaskoYapildi"
                                            label="Kasko Yapıldı"
                                            checked={kaskoYapildi}
                                            onChange={(e) => {
                                                setKaskoYapildi(e.target.checked);
                                                if (!e.target.checked) {
                                                    setKaskoBedeli(0);
                                                    setFormattedKaskoBedeli('0');
                                                }
                                            }}
                                        />
                                    </Form.Group>

                                    {kaskoYapildi && (
                                        <Form.Group className="mb-3">
                                            <Form.Label>Kasko Bedeli (TL) *</Form.Label>
                                            <div className="input-group">
                                                <span className="input-group-text">₺</span>
                                                <Form.Control
                                                    type="text"
                                                    value={formattedKaskoBedeli}
                                                    onChange={(e) => handleFormattedNumberChange('kaskoBedeli', e.target.value)}
                                                    placeholder="0"
                                                    required
                                                />
                                            </div>
                                            <Form.Text className="text-muted">
                                                Kasko bedeli vadelendirilecek tutara eklenecektir
                                            </Form.Text>
                                        </Form.Group>
                                    )}

                                {/* SENET BAŞLANGIÇ TARİHİ CALENDAR KONTROLÜ
                                    * ========================================
                                    *
                                    * Bu input müşterinin senet başlangıç tarihini seçmesini sağlar.
                                    *
                                    * MANTIK:
                                    * - Normal senet başlangıcı: Bugün + 1 ay (örn: 14/8 → 14/9)
                                    * - Ertelemeli senet: Normal başlangıç + maksimum 90 gün erteleme
                                    *
                                    * KURALLAR:
                                    * - Minimum: Bugün (geçmiş tarih seçilemez)
                                    * - Maximum: Bugün + 1 ay + 90 gün (~120 gün total)
                                    *
                                    * DURUM-1: Normal senet (bugün + 1 ay + hafta sonu kontrolü)
                                    * DURUM-2: Ertelemeli senet (normal başlangıç + X gün, max 90 gün erteleme)
                                    *
                                    * Müşteri seçtiği tarihten itibaren taksitlerini ödemeye başlar.
                                    */}
                                    <Form.Group className="mb-3">
                                        <Form.Label>Senet Başlangıç Tarihi *</Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={senetBaslangicTarihi}
                                            onChange={(e) => setSenetBaslangicTarihi(e.target.value)}
                                            min={new Date().toISOString().split('T')[0]} // Bugün (geçmiş tarih yok)
                                            max={new Date(Date.now() + 120 * 24 * 60 * 60 * 1000).toISOString().split('T')[0]} // Bugün + ~120 gün (1 ay + 90 gün erteleme)
                                            required
                                        />
                                        <Form.Text className="text-muted">
                                            İlk taksit bu tarihte başlayacaktır (Normal başlangıç + max 90 gün erteleme)
                                        </Form.Text>
                                    </Form.Group>

                                    {/*
                                    * HESAPLAMA SONUÇLARI UI İYİLEŞTİRMESİ
                                    * ====================================
                                    *
                                    * Bu kod parçası calculations card'daki kredi tutarı bölümünü dinamik hale getirir:
                                    *
                                    * DURUM-1 (Normal): "Kredi Tutarı: X TL"
                                    * DURUM-2 (Ertelemeli): "Yeni Kredi Tutarı: X TL" + detay bilgisi
                                    *
                                    * Müşteri erteleme yaptığında ne kadar ek ödeme yapacağını net görebilir.
                                    */}
                                    {calculations && (
                                        <Card bg="light" className="mt-4">
                                            <Card.Body>
                                                <h6 className="text-primary mb-3">
                                                    <FaCalculator className="me-2" />
                                                    Hesaplama Sonuçları (PMT)
                                                </h6>

                                                {/* Erteleme uyarısı (varsa) */}
                                                {calculations.isDeferred && calculations.deferredDays > 0 && (
                                                    <Alert variant="warning" className="mb-3">
                                                        <strong>⏰ {calculations.deferredDays} Gün Ertelemeli Ödeme</strong>
                                                    </Alert>
                                                )}

                                                {/* *** DİNAMİK KREDİ TUTARI BÖLÜMÜ *** */}
                                                {calculations.isDeferred ? (
                                                    // DURUM-2: Ertelemeli Senet
                                                    <div className="mb-3">
                                                        <small className="text-muted">Yeni Kredi Tutarı:</small>
                                                        <p className="mb-1 fw-bold text-primary">{formatNumber(calculations.finalLoanAmount)} TL</p>
                                                        <small className="text-muted">
                                                            <span className="d-block">Orijinal: {formatNumber(calculations.loanAmount)} TL</span>
                                                            <span className="d-block text-warning">+ Erteleme Faizi: {formatNumber(calculations.deferredInterest)} TL</span>
                                                        </small>
                                                    </div>
                                                ) : (
                                                    // DURUM-1: Normal Senet
                                                    <div className="mb-3">
                                                        <small className="text-muted">Kredi Tutarı:</small>
                                                        <p className="mb-2 fw-bold">{formatNumber(calculations.loanAmount)} TL</p>
                                                    </div>
                                                )}

                                                {/* Diğer hesaplama sonuçları (değişiklik yok) */}
                                                <div>
                                                    <small className="text-muted">Aylık Ödeme:</small>
                                                    <p className="mb-2 fw-bold">{formatNumber(calculations.monthlyPayment)} TL</p>
                                                </div>
                                                <div>
                                                    <small className="text-muted">Toplam Ödeme:</small>
                                                    <p className="mb-2 fw-bold">{formatNumber(calculations.totalPayment)} TL</p>
                                                </div>
                                                <div>
                                                    <small className="text-muted">Toplam Faiz:</small>
                                                    <p className="mb-0 fw-bold">{formatNumber(calculations.totalInterest)} TL</p>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                    )}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    {/* Notlar */}
                    <Col md={12}>
                        <Card className="mb-4">
                            <Card.Header>
                                <h5 className="mb-0">Notlar</h5>
                            </Card.Header>
                            <Card.Body>
                                <Form.Group>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        placeholder="Rapor ile ilgili notlarınız..."
                                        value={notes}
                                        onChange={(e) => setNotes(e.target.value)}
                                    />
                                </Form.Group>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col className="text-center">
                        <Button
                            variant="primary"
                            type="button"
                            size="lg"
                            disabled={loading}
                            className="px-5"
                            onClick={() => setShowConfirmModal(true)}
                        >
                            {loading ? 'Kaydediliyor...' : (
                                <>
                                    <FaSave className="me-2" />
                                    Raporu Kaydet
                                </>
                            )}
                        </Button>
                    </Col>
                </Row>
            </Form>          
        </Container>

        {/* Confirmation Modal */ }
    <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)} centered>
        <Modal.Header closeButton>
            <Modal.Title>Raporu Kaydet</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <p>Bu raporu kaydetmek istediğinizden emin misiniz?</p>
            <p className="text-muted">Kaydetme işlemi tamamlandıktan sonra düzenleme yapabilirsiniz.</p>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>
                Düzenlemeye Devam Et
            </Button>
            <Button variant="primary" onClick={handleConfirmSubmit} disabled={loading}>
                {loading ? 'Kaydediliyor...' : 'Kaydet ve Bitir'}
            </Button>
        </Modal.Footer>
            </Modal>
        </>
    );
};

export default ReportGeneratorPage;